import { createSelector } from 'reselect';

// Selector to get the list of available camera and audio devices
export const getDevices = createSelector(
    [
        (state) => state?.selectedCameraId,
        (state) => state.selectedAudioId,
    ],
    // Output selector function: Asynchronously enumerates and categorizes available devices
    async (selectedCameraId, selectedAudioId) => {
        console.log('get devices');

        const cameraDevices = [];
        const audioDevices = [];

        try {
            // Enumerate available media devices using WebRTC API
            const devices = await navigator.mediaDevices.enumerateDevices();

            devices.forEach((device) => {
                // Categorize devices based on their kind (videoinput or audioinput)
                if (device.kind === 'videoinput') {
                    if (selectedCameraId && selectedCameraId === device.deviceId) {
                        device.selected = true;
                    }
                    cameraDevices.push(device);
                }
                if (device.kind === 'audioinput') {
                    if (selectedAudioId && selectedAudioId === device.deviceId) {
                        device.selected = true;
                    }
                    audioDevices.push(device);
                }
            });

            // If the user has not selected a camera or audio option, the first option is automatically selected
            if (!selectedCameraId && cameraDevices[0]) {
                cameraDevices[0].selected = true;
            }
            if (!selectedAudioId && audioDevices[0]) {
                audioDevices[0].selected = true;
            }

            return {
                cameraDevices,
                audioDevices,
            };
        } catch (error) {
            // Log error if device enumeration fails and return empty arrays
            console.error('Error enumerating devices:', error);
            return {
                cameraDevices,
                audioDevices,
            };
        }
    },
);
